import api from '@api/endpoints';
import { FAST_TRANSFER_MANAGER_CONSTANTS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';


export const getFastTransferConfig = ({
  onSuccess,
  onComplete
}) => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_FAST_TRANSFER_CONFIG
    });

    const { data } = await api.fastTransferManager.getFastTransferConfig();

    dispatch({
      type: types.GET_FAST_TRANSFER_CONFIG_SUCCESS,
      payload: data
    });

    onSuccess && onSuccess(data);
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message || 'Failed to fetch fast transfer configuration',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.GET_FAST_TRANSFER_CONFIG_FAILURE,
      payload: error.message
    });
  } finally {
    onComplete && onComplete();
  }
};


export const updateFastTransferConfig = ({
  payload,
  onSuccess,
  onComplete
}) => async (dispatch) => {
  try {
    dispatch({
      type: types.UPDATING_FAST_TRANSFER_CONFIG
    });

    const { data } = await api.fastTransferManager.updateFastTransferConfig({
      payload: payload
    });

    dispatch({
      type: types.UPDATE_FAST_TRANSFER_CONFIG_SUCCESS,
      payload: data
    });

    onSuccess && onSuccess(data);

    dispatch(
      setAlert({
        title: 'Fast Transfer Configuration updated successfully!',
        status: ALERT_STATUS_TYPE.SUCCESS
      })
    );
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message || 'Failed to update fast transfer configuration',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.UPDATE_FAST_TRANSFER_CONFIG_FAILURE,
      payload: error.message
    });
  } finally {
    onComplete && onComplete();
  }
};
